import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./advantage.module.scss";

function Advantage({text, icon}) {
  return (
    <div className={styles.root}>
      <div className={classNames(styles.icon, styles[`${icon}Icon`])}></div>
      <p className={styles.text}>{text}</p>
    </div>
  );
}

Advantage.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string
};

export default Advantage;
